import { Component, OnInit } from '@angular/core';
import { StoreDataService } from '@common/services/store-data.service';
import { ActivatedRoute } from '@angular/router';

import { Profile } from '@common/models/profile.model';
import { OFFICE_ADDRESS_CONFIG, URL_CONFIG } from '@constants/locations.constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent implements OnInit {
    country!: string;
    footerAddress!: string;
    localSiteUrl!: string;
    termsOfUseUrl!: string;
    privacyPolicyUrl!: string;
    accessibilityUrl!: string;
    doNotShareUrl!: string;
    currentYear = new Date().getFullYear();

    constructor(private storeDataService: StoreDataService, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            if (Object.keys(params).length > 0 && params['country']) {
                this.country = params['country'];
                this.setLocationConfig();
            } else {
                this.storeDataService.profileObserver().subscribe((profile: Profile) => {
                    if (profile.profileId && !profile.skipUpdate) {
                        this.country = profile.country ? profile.country : 'US';
                        this.setLocationConfig();
                        delete profile.skipUpdate;
                    }
                });
            }
        });
    }
    setLocationConfig(): void {
        this.footerAddress = OFFICE_ADDRESS_CONFIG[this.country];
        this.localSiteUrl = URL_CONFIG[this.country].LOCAL_SITE;
        this.termsOfUseUrl = URL_CONFIG[this.country].TERMS_OF_USE;
        this.privacyPolicyUrl = URL_CONFIG[this.country].PRIVACY_POLICY;
        this.accessibilityUrl = URL_CONFIG[this.country].ACCESSIBILITY;
        this.doNotShareUrl = URL_CONFIG[this.country].DO_NOT_SHARE;
    }
}
